module.exports = "/_next/static/images/reset-password-success-2d9ad49e0f6fd0cdf702121f29e118df.svg";